(function($) {

  $(document).ready(function() {
    victorTheme.init();
  }); 

  $(document).on('click','.overlay, .close-window', function() {   
    hidePopup('.victor-popup'); 

    setTimeout(function(){
      $('.loading').removeClass('loaded-content');
    },500);
    return false;
  });

  $('.dropdown-toggle').click(function() {
    $('.dropdown-content').removeClass('active');
    $(this).next().toggleClass('active');    
    return false;              
  });  

  var victorTheme = { 
    init: function() {
      this.initHideDropdown();
      this.initToggle(); 
      this.initSearch();
      this.initDropDownCart();
      this.initProductAddToCart();
      /* Mobile Menu */
      this.initMobileMenu();
      this.initHero();
      this.initHeroHeader();
      this.initAnnounce();
      this.initFeaturedTabs();
      this.initFooterAccordion();
    },

    initAnnounce: function() {
      var $items = $('[data-victor-announce] .victor-announce__item');
      if ($items.length < 2) return;
      var i = 0;
      setInterval(function() {
        $items.removeClass('is-active');
        i = (i + 1) % $items.length;
        $items.eq(i).addClass('is-active');
      }, 4500);
    },

    initFeaturedTabs: function() {
      $(document).on('click', '[data-featured-tab]', function(e) {
        e.preventDefault();
        var id = $(this).attr('data-featured-tab');
        var $root = $(this).closest('.victor-featured');
        $root.find('[data-featured-tab]').removeClass('is-active').attr('aria-selected', 'false');
        $(this).addClass('is-active').attr('aria-selected', 'true');
        $root.find('[data-featured-panel]').removeClass('is-active');
        $root.find('[data-featured-panel="' + id + '"]').addClass('is-active');
      });
    },

    initFooterAccordion: function() {
      $(document).on('click', '.victor-footer__toggle', function() {
        if (window.matchMedia('(min-width: 768px)').matches) return;
        var $col = $(this).closest('[data-footer-acc]');
        var open = !$col.hasClass('is-open');
        $col.toggleClass('is-open', open);
        $(this).attr('aria-expanded', open ? 'true' : 'false');
      });
    },

    initHeroHeader: function() {
      var $body = $('body');
      var $header = $('[data-victor-header]');
      if (!$header.length) return;

      function update() {
        if ($(window).scrollTop() > 24) {
          $body.addClass('hero-scrolled');
          $header.addClass('is-stuck');
        } else {
          $body.removeClass('hero-scrolled');
          $header.removeClass('is-stuck');
        }
      }

      $(window).on('scroll.victorHeroHeader resize.victorHeroHeader', update);
      update();
    },

    initHero: function() {
      var $hero = $('[data-victor-hero]');
      if (!$hero.length) return;

      var $slides = $hero.find('.victor-hero__slide');
      var total = $slides.length;
      if (total < 2) return;

      var index = 0;
      var timer = null;
      var delay = 5000;

      function go(n) {
        index = (n + total) % total;
        $slides.removeClass('is-active').eq(index).addClass('is-active');
        $hero.find('.victor-hero__dot').removeClass('is-active').eq(index).addClass('is-active');
      }

      function next() { go(index + 1); }
      function prev() { go(index - 1); }

      function start() {
        stop();
        timer = setInterval(next, delay);
      }
      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      $hero.on('click', '[data-hero-next]', function(e) { e.preventDefault(); next(); start(); });
      $hero.on('click', '[data-hero-prev]', function(e) { e.preventDefault(); prev(); start(); });
      $hero.on('click', '[data-hero-goto]', function(e) {
        e.preventDefault();
        go(parseInt($(this).attr('data-hero-goto'), 10) - 1);
        start();
      });

      $hero.on('mouseenter', stop).on('mouseleave', start);
      start();
    },

    /* Hide Dropdown */
    initHideDropdown: function(){
      $(document).on('click touchstart', function(e) {
        var mobileMenu = $(".main-menu");
        var topCart = $(".topCart");
        var dropdown = $(".dropdown-content");
        if (!mobileMenu.is(e.target) && mobileMenu.has(e.target).length === 0 && !topCart.is(e.target) && topCart.has(e.target).length === 0 && !dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
          mobileMenu.removeClass('active');
          topCart.removeClass('active');
          dropdown.removeClass('active');      
        }
      });
    },


    /* Dropdown Toggle */
    initToggle: function(){
      $('.caret').click(function() {        
        $(this).parent().next().toggleClass('active');        
        return false; 
      }); 

      $(".block-category .sub-menu > li").each( function(){
        if($(this).hasClass('active')){
          $(this).parent().addClass('active');
        }
      });

      $('.dropdown-toggle').click(function() {
        $('.dropdown-content').removeClass('active');
        $(this).next().toggleClass('active');    
        return false;              
      });   
    },
    
    /* --------------------------------------------------------- */
    /* Search */
    initSearch: function() {
      $('.btn-search').click(function(event) {   
        showPopup('.search-popup');
        event.preventDefault();      

      });     

    },  

    /* --------------------------------------------------------- */
    /* Mobile Menu */
    initMobileMenu: function() {

      $('.mobile-menu').click(function() {      
        $(this).parent().toggleClass('active');    
        return false; 
      });   
    }, 


    /* Check Item Mini Cart */
    checkItemsInMiniCart: function() {
      if($('.mini-cart .mini-products-list').children().length > 0) {
        $('.mini-cart').addClass('hasItem');          
      } else{
        $('.mini-cart').removeClass('hasItem'); 
      }
    },

    /* Mini Cart Click to Show */
    initDropDownCart: function() {      
      $('.dropdow .cartCount').click(function() {
        $(this).parent('.topCart').toggleClass('active');
      });            
      victorTheme.checkItemsInMiniCart();

      $('.mini-cart .btn-remove').click(function(event) {       
        event.preventDefault();
        var productId = $(this).parents('.item').attr('id');
        productId = productId.match(/\d+/g);
        Shopify.removeItem(productId, function(cart) {
          doUpdateMiniCart(cart);       
        });
      });
    },


    /* ------------------------------- */
    /* Product detail - Add to cart */

    initProductAddToCart: function() {
      $('#product-addTocart').click(function(event) {

        event.preventDefault();
        if ($(this).attr('disabled') != 'disabled') {
          var variant_id = $('#AddToCartForm select[name=id]').val();
          if (!variant_id) {
            variant_id = $('#AddToCartForm input[name=id]').val();
          }
          var quantity = $('#AddToCartForm input[name=quantity]').val();
          if (!quantity) {
            quantity = 1;
          }
          var title = $('h1.product-name').html();
          var image = $('#ProductPhotoImg').attr('src');
          doAjaxAddToCart(variant_id, quantity, title, image);
        }
        return false;
      });

    },

  }

  })(jQuery);